export const PRIVACY_SECTIONS = [
  {
    title: 'Local Catalog Data',
    body: `Your images, descriptions, tags, categories and other catalog contents are stored locally on your device using your browser's IndexedDB storage.

Pictalog does not upload your catalog contents to its servers and does not share them with third parties.

Clearing your browser data, resetting the browser or uninstalling the PWA may permanently delete your locally stored catalog. We recommend exporting important catalogs regularly.`
  },
  {
    title: 'Technical Data',
    body: `When you access Pictalog, the web server or hosting provider may automatically receive limited technical information, such as your IP address, browser type, operating system and date and time of access.

This information may be processed to deliver the app, maintain security and resolve technical problems. Pictalog does not use the contents of your local catalog for these purposes.`
  },
  {
    title: 'Data Retention',
    body: `Your catalog data remains stored locally on your device until you delete it, clear Pictalog's site data or the browser removes it.

Technical server logs may be retained temporarily for security, maintenance and troubleshooting purposes.`
  },
  {
    title: 'Changes to This Policy',
    body: `We may update this Privacy Policy when Pictalog or applicable legal requirements change.

The updated version will be published in the app.`
  }
];
